import { Expose, Transform, Type } from "class-transformer";
import { parseAppDate } from "@/utils/dates/dateFormats";
import { AcquisitionTypeEnum, UsageTypeEnum, VehicleFuelTypeEnum, VehicleTypeEnum } from "@altertec_gparn/lib";
import { toCents } from "@/utils/numberUtils";

export class CreateVehicleDto {
  @Expose()
  code: string;

  @Expose()
  licensePlate: string;

  @Expose()
  brand: string;

  @Expose()
  model: string;

  @Expose()
  @Transform(({ value }) => toCents(value))
  dailyCost: number;

  @Expose()
  archived: boolean;

  @Expose()
  companyId: string;

  @Expose()
  operativeUnitId: string;

  @Transform(({ value }) => parseAppDate(value, false))
  @Expose()
  registrationDate?: Date;

  @Transform(({ value }) => parseAppDate(value, false))
  @Expose()
  deregistrationDate?: Date;

  @Expose()
  vehicleType?: VehicleTypeEnum;

  @Expose()
  usageType?: UsageTypeEnum;

  @Expose()
  acquisitionType?: AcquisitionTypeEnum;

  @Expose()
  solredCardNumber?: string;

  @Expose()
  solredCardPin?: string;

  @Expose()
  vehicleFuelType?: VehicleFuelTypeEnum;

  @Expose()
  @Type(() => Number)
  seatsCount?: number;

  @Expose()
  responsibleId?: string | null;
}
